module.exports = __webpack_public_path__ + "static/media/lock-error.17da5cb2.svg";